import { useState, useEffect, useRef } from "react";

import Hls from "hls.js";

import Loading from "../../Loading/Loading";
import ErrorMessage from "../../AlertMessage/ErrorMessage";

import './PlayerTrailer.scss'
import close_btn_image from '../modal_yt_player/images/close.png'


var timeout_message = null

export default function PlayerTrailer({ movieInfo, setShowTrailer }) {

    const ref_trailer = useRef(null)

    const [showLoading, setShowLoading] = useState(false)
    const [hls, setHls] = useState(null)
    const [message, setMessage] = useState({
        text: '',
        type: '',
        show: false
    })

    useEffect(() => {

        play_trailer(movieInfo.trailer_url)

    }, [])

    const play_trailer = (url) => {

        // url = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
        // url = 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8'

        if (url.indexOf('.mp4') > -1) {
            ref_trailer.current.src = url

            return
        }

        if (Hls.isSupported()) {

            if (hls) hls.destroy();
            let _hls = new Hls();

            setHls(_hls)
            // if (showErrorMessage) setShowErrorMessage(false)

            _hls.loadSource(url);
            _hls.attachMedia(ref_trailer.current);

            _hls.on(Hls.Events.AUDIO_TRACK_LOADED, function (err, data) {
                // setAudioTracks(_hls.audioTracks);
            })
            _hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, function (e, data) {
                // setActiveAudioTrack(_hls.audioTrack);
            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_LOADED, function (e, data) {
                // setSubtitles(_hls.subtitleTracks);
            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_SWITCH, function (e, data) {
                // setActiveSub(_hls.subtitleTrack);
            });

            ref_trailer.current.onerror = () => {
                err_message()
            }

            // if(activeMedia){
            _hls.on(Hls.Events.ERROR, function (err, data) {

                err_message()

            });


        }

        ref_trailer.current.onloadedmetadata = () => {
            setShowLoading(false)
        }

    }

    const err_message = () => {
        setMessage({
            text: 'Trailers are not available for this movie',
            type: 'error',
            show: true
        })
        hide_error_message()
    }

    const hide_error_message = () => {

        clearTimeout(timeout_message)

        timeout_message = setTimeout(() => {
            setShowTrailer(false)
            setMessage({
                text: '',
                type: '',
                show: false
            })
        }, 3000);

    }


    return (
        <>
            <ErrorMessage text={message.text} type={message.type} show={message.show} />

            <div className="parent_modal" onClick={() => setShowTrailer(false)}>
                {showLoading ?
                    <Loading /> : null}
                <img src={close_btn_image} alt="" />
            </div>
            <div className="modal">

                <video
                    autoPlay
                    id={'trailer_player'}
                    ref={ref_trailer}
                    src=""
                ></video>
            </div>
        </>
    )

}